import { createSelector } from 'reselect';
import { getClassroom } from './classroom-selectors';

export const studentsSelector = state => state.entity.students;
export const studentsByIdSelector = state => state.entity.studentsById;

export const getClassroomStudents = createSelector(
  [getClassroom, studentsByIdSelector],
  (classroom, studentsById) => {
    if (!classroom) return [];
    return classroom.studentIds.reduce(
      (acc, id) => (studentsById[id] ? [...acc, studentsById[id]] : acc),
      []
    );
  }
);

export const getStudent = (state, { studentId }) =>
  studentId ? state.entity.studentsById[studentId] : null;
